/* tslint:disable */
/* eslint-disable */
/**
 * Webclipping
 * WebclippingのAPI
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ArticlePastSearchListItemV2,
    ArticlePastSearchListItemV2FromJSON,
    ArticlePastSearchListItemV2FromJSONTyped,
    ArticlePastSearchListItemV2ToJSON,
} from './ArticlePastSearchListItemV2';
import {
    ArticlePastSearchV2Pager,
    ArticlePastSearchV2PagerFromJSON,
    ArticlePastSearchV2PagerFromJSONTyped,
    ArticlePastSearchV2PagerToJSON,
} from './ArticlePastSearchV2Pager';

/**
 * 過去記事検索V2の検索結果
 * @export
 * @interface ArticlePastSearchV2
 */
export interface ArticlePastSearchV2 {
    /**
     * 
     * @type {ArticlePastSearchV2Pager}
     * @memberof ArticlePastSearchV2
     */
    pager: ArticlePastSearchV2Pager;
    /**
     * 
     * @type {Array<ArticlePastSearchListItemV2>}
     * @memberof ArticlePastSearchV2
     */
    articleList: Array<ArticlePastSearchListItemV2>;
    /**
     * 過去記事検索レポートのID
     * @type {number}
     * @memberof ArticlePastSearchV2
     */
    reportPastSearchId: number;
}

export function ArticlePastSearchV2FromJSON(json: any): ArticlePastSearchV2 {
    return ArticlePastSearchV2FromJSONTyped(json, false);
}

export function ArticlePastSearchV2FromJSONTyped(json: any, ignoreDiscriminator: boolean): ArticlePastSearchV2 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'pager': ArticlePastSearchV2PagerFromJSON(json['pager']),
        'articleList': ((json['article_list'] as Array<any>).map(ArticlePastSearchListItemV2FromJSON)),
        'reportPastSearchId': json['report_past_search_id'],
    };
}

export function ArticlePastSearchV2ToJSON(value?: ArticlePastSearchV2 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'pager': ArticlePastSearchV2PagerToJSON(value.pager),
        'article_list': ((value.articleList as Array<any>).map(ArticlePastSearchListItemV2ToJSON)),
        'report_past_search_id': value.reportPastSearchId,
    };
}

